const CONFIG = {
  apiKey: "AIzaSyCb5jn_qiP1TJPUESXv-EYDGWlqUnnbXrM",
  authDomain: "aha-move.firebaseapp.com",
  databaseURL: "https://aha-move.firebaseio.com",
  projectId: "aha-move",
  storageBucket: "aha-move.appspot.com",
  messagingSenderId: "188147882581",
  appId: process.env.VUE_APP_FIREBASE_AUTH_APP_ID
};

const mixin = {
  methods: {
    $_firebaseAuth_init() {
      // console.log("initFirebase");

      if (global.firebase.apps.length === 0) {
        window.firebaseAuthApp = global.firebase.initializeApp(CONFIG);
        window.firebaseAuthApp.auth().languageCode = "vn";
      }
      this.$_firebaseAuth_initInvisibleRecapcha();
    },
    $_firebaseAuth_initInvisibleRecapcha() {
      // console.log("initInvisibleRecapcha");
      // Config invisible reCAPTCHA require specifying the ID of the button that submits sign-in form

      return new Promise(resolve => {
        window.recaptchaVerifier = new global.firebase.auth.RecaptchaVerifier(
          "re-captcha",
          {
            size: "invisible",
            badge: "bottomright",
            callback: () => {
              // reCAPTCHA solved, allow signInWithPhoneNumber.
              // console.log("reCAPTCHA solved");
              resolve();
            },
            "expired-callback": error => {
              // Response expired. Ask user to solve reCAPTCHA again.
              console.log("expired-callback", error);
              this.$_firebaseAuth_resetRecaptcha();
            },
            "error-callback": error => {
              console.log("error-callback", error);
              this.$_firebaseAuth_resetRecaptcha();
            }
          }
        );
      });
    },
    $_firebaseAuth_resetRecaptcha() {
      if (window.grecaptcha && window.recaptchaVerifier) {
        window.recaptchaVerifier.render().then(function(widget_id) {
          window.grecaptcha.reset(widget_id);
        });
      }
    },

    $_firebaseAuth_sendOTP(mobile) {
      return new Promise((resolve, reject) => {
        if (!mobile)
          return reject("Authenticate with Firebase require phone number");

        // TODO remove hardcode formatedPhoneWithCountryCode
        const formatedPhoneWithCountryCode = `+${mobile}`;
        window.firebaseAuthApp
          .auth()
          .signInWithPhoneNumber(
            formatedPhoneWithCountryCode,
            window.recaptchaVerifier
          )
          .then(confirmation => {
            resolve(confirmation);
          })
          .catch(error => {
            // Error; SMS not sent
            // .eg: auth/too-many-request
            reject(error.message);
          });
      });
    }
  },
  async mounted() {
    global.firebase = await new Promise(resolve => {
      import(/* webpackMode: "lazy" */ "firebase").then(module => {
        resolve(module);
      });
    });

    this.$_firebaseAuth_init();
  }
};

export default mixin;
